import array from '@mailobj-browser/front/js/utils/array.js'
import contract from '@mailobj-browser/front/js/contracts/contract.js'
import adbookForm from './adbookForm.js'
import adbookSelected from './adbookSelected.js'
import ccBcc from './ccBcc.js'
import favorites from './favorites.js'
import quickAttach from './quickAttach.js'
import spaces from './spaces.js'
import options from './options/options.js'

export default contract({
  adbookForm: array([
    adbookForm
  ]),
  ccBcc: array([
    ccBcc
  ]),
  favorites: array([
    favorites
  ]),
  options,
  quickAttach: array([
    quickAttach
  ]),
  spaces: array([
    spaces
  ]),
  adbookSelected: array([
    adbookSelected
  ]),
})
